import { useSelector } from "react-redux"
import styled from "styled-components"
import { NavLink } from "react-router-dom"

import TitleHeader from "components/presenters/header/TitleHeader"

export default function ProductDetailHeader() {
  const { productInfo } = useSelector((state) => state.productDetailInfo)

  return (
    <HeaderWrapper>
      <TitleHeader title={productInfo?.title} prevURL={"/motishop"} isShare={true} />
      <HeaderNavBar>
        <HeaderNavList>
          <HeaderNavItem>
            <HeaderNavLink
              to={`/motishop/product/${productInfo.no}/info`}
              isActive={(_, location) => {
                return !location.pathname.includes("achievement")
              }}
            >
              정보
            </HeaderNavLink>
          </HeaderNavItem>
          <HeaderNavItem>
            <HeaderNavLink to={`/motishop/product/${productInfo.no}/achievement`} exact>
              인증현황
            </HeaderNavLink>
          </HeaderNavItem>
        </HeaderNavList>
      </HeaderNavBar>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  width: 100%;
  height: calc(100vw * (90 / 375));
  min-height: calc(100vw * (90 / 375));
`

const HeaderNavBar = styled.div`
  position: fixed;
  top: calc(100vw * (54 / 375));
  width: 100%;
  z-index: 1;
`

const HeaderNavList = styled.ul`
  background-color: #fff;
`

const HeaderNavItem = styled.li`
  display: inline-block;
  width: 25%;
`

const HeaderNavLink = styled(NavLink)`
  width: 100%;
  text-align: center;
  font-style: normal;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  font-weight: 400;
  padding-bottom: calc(100vw * (14 / 375));
  &.active {
    border-bottom: calc(100vw * (3 / 375)) solid #121212;
    font-weight: 700;
  }
`
